import React from "react"
import { Box, ButtonEcomm } from "@ncs/web-legos"
import { css, Theme } from "@emotion/react"
export interface ErrorPageProps {
	title?: string
	description?: string
}

export const ErrorPage: React.FC<ErrorPageProps> = ({ title, description }) => {
	const goToHomeHandler = () => {
		window.location.href = "/shop"
	}

	return (
		<div css={errorPageStyle}>
			<Box
				d="flex"
				flexDirection="column"
				justifyContent="center"
				alignItems="center"
				css={errorContainerStyle}
			>
				<h1 css={titleStyle}>{title}</h1>
				{description &&
					description
						.split(".")
						.filter((p) => p.trim())
						.map((paragraph) => (
							<p key={paragraph} css={descriptionStyle}>
								{paragraph}.
							</p>
						))}
				<ButtonEcomm
					css={goToHomePageButtonStyle}
					variant="primary-cta"
					fillContainer
					onClick={goToHomeHandler}
				>
					<span>GO TO HOMEPAGE</span>
				</ButtonEcomm>
			</Box>
		</div>
	)
}

const goToHomePageButtonStyle = (theme: Theme) => css`
	width: 416px;
	margin: 0 auto;
	margin-top: 3rem;

	${theme.breakpoints.only("xs")} {
		width: 100%;
	}

	span {
		color: #fff;
		text-align: right;
		font-size: 16px;
		font-style: normal;
		font-weight: 700;
		line-height: normal;
		text-transform: uppercase;
	}
`

const descriptionStyle = (theme: Theme) => css`
	color: #4b5563;
	text-align: center;
	font-size: 16px;
	font-style: normal;
	font-weight: 500;
	line-height: 24px;
`

const titleStyle = (theme: Theme) => css`
	color: #111827;
	text-align: center;
	font-size: 36px;
	font-style: normal;
	font-weight: 700;
	letter-spacing: -0.72px;
	margin-bottom: 1.2rem;
`

const errorContainerStyle = (theme: Theme) => css`
	border-radius: 12px;
	border: 1px solid #d1d5db;
	background: white;
	min-width: 560px;
	padding: 3em;
	min-height: auto;
	height: auto;

	${theme.breakpoints.only("xs")} {
		padding: 3em;
		min-width: 300px;
	}
`

const errorPageStyle = (theme: Theme) => css`
	display: flex;
	justify-content: center;
	align-items: center;
	min-height: auto;
	height: auto;
	margin-top: 3em;

	${theme.breakpoints.only("xs")} {
		min-height: auto;
	}
`
